<template>
	<div class="page__bd single-page-wrap">
		<div class="weui-tab">
			<div class="weui-navbar">
				<div v-for="(item,index) of navBarList" :key="item.id"
					 class="weui-navbar__item"
					 :class="navItemIdx === index ? 'weui-bar__item_on':''"
					 @click="handleNavBar(item.id,index)">{{item.name}}</div>
			</div>
			<cube-scroll ref="scroll" class="cube-scroll" :options="scrollOptions">
				<div class="weui-tab-panel" v-if="feeList && feeList.length > 0">
					<div v-for="(item,index) of feeList" :key="item.id" class="fee-item-wrapper"
						 :class="feeIdx === index?'active':''" @click="handleFeeItem(index,item)">
						<h6>{{item.title}}</h6>
						<p>券名：{{item.couponTypeName}}</p>
						<p>售价：{{item.actsaleMoney}}元</p>
						<p v-show="item.availableBuyNum != 0">可购数量：{{item.availableBuyNum}}</p>
						<div class="effect-date-wrapper" :class="feeIdx === index?'active':''">
							<p>有效期{{item.ytype == 2 ? '截止至': ''}}: {{item.timeMark}}</p>
						</div>
						<i v-show="item.isExpiration === 1" class="iconfont icon-guoqi"></i>
					</div>
				</div>
				<no-data v-else msg="暂无"></no-data>
			</cube-scroll>

			<div ref="form" class="weui-form-area">
				<div class="weui-cells weui-cells_form">
					<div class="weui-cell weui-cell_vcode">
						<div class="weui-cell__hd">
							<label class="weui-label">数量</label>
						</div>
						<div class="weui-cell__bd">
							<input class="weui-input" type="tel" maxlength="4" v-model.trim="count" @blur="blur"
								   required emptyTips="请输入停车券张数"  placeholder="请输入停车券张数">
						</div>
					</div>
					<div class="weui-cell weui-cell_vcode">
						<div class="weui-cell__hd">
							<label class="weui-label">备注</label>
						</div>
						<div class="weui-cell__bd">
							<input class="weui-input" type="text" v-model.trim="remark" placeholder="用于区别其他停车券" @blur="blur">
						</div>
					</div>
				</div>
				<div class="weui-btn-area">
					<button class="weui-btn"
							:class="!couponvalueId ? 'weui-btn_disabled': 'weui-btn_primary'"
							:disabled="!couponvalueId"
							@click="confirm" >立即购买</button>
					<p>付款后等待10秒左右，停车券即可生成完毕。</p>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
    import { listBusinesscou, buyCoupon } from "../../../api/coupon/parkingFeeList";
    import { pay } from "../../../api/coupon/pay";
    import { mapGetters } from 'vuex'
    export default {
        name: "index",
        data () {
            return{
                feeIdx: undefined,
                navItemIdx: 0,
                count: undefined,
                remark: undefined,
                couponvalueId: undefined,
                navBarList: [
                    {id:2,name:'金额券'},
                    {id:1,name:'时间券'},
                    {id:0,name:'单次券'},
                ],
                timeMarkOptions: {
                    0: '长期有效',
                    1: '当天有效',
                    3: '隔日有效'
                },
                feeList: [],
                scrollOptions: {
                    click: true,
                    bounce: false
                },
            }
        },
        computed: {
            ...mapGetters(['userOpenid','checkedParkingLotId','userPhone'])
        },
        mounted () {
            this.type = this.navBarList[0].id;
            this.getBusinessCouponList()
        },
        methods: {
            blur() {
                window.scrollTo(0,0)
			},
            /** 导航操作*/
            handleNavBar (id,index) {
                this.feeIdx = undefined;
                this.couponvalueId = undefined;
                this.type = id;
                this.navItemIdx = index;
                this.$refs.scroll.scrollTo(0,0,200);
                this.getBusinessCouponList()
            },
            /** 点击券操作*/
            handleFeeItem (index,item) {
                if (item.isExpiration === 1) return;
                this.feeIdx = index;
                this.couponvalueId = item.coupontypeId
            },
            /** 立即购买按钮操作 */
            confirm () {

				

                let form = this.$refs['form'];
                this.$weui.form.validate(form, (error) => {
                    if (!error){
						this.showNtConfirm()
                        // this.buyCoupon()
                    }
                });


            },

			showNtConfirm() {
                this.$createDialog({
                    type: "confirm",
                    icon: "cubeic-location",
                    title: this.plateName,
                    content:"请您务必在驾车驶离前（即车辆到达出口处之前）购买电子停车券并绑定车辆。否则，相关费用按照临时停车标准收取。",
                        
                    confirmBtn: {
                        text: "确定",
                        active: true,
                        disabled: false,
                        href: "javascript:;"
                    },
                    cancelBtn: {
                        text: "取消",
                        active: false,
                        disabled: false,
                        href: "javascript:;"
                    },
                    onConfirm: () => {
						this.buyCoupon()
                    },
                    onCancel: () => {
                        this.$createToast({
                            type: "warn",
                            time: 3000,
                            txt: "取消"
                        }).show();
                  
                        this.isShowHint = false;
                    }
                }).show();
            },


            buyCoupon () {
                let form = {
                    openid: localStorage.getItem('userOpenId')||this.userOpenid ,
                    parkinglotId: this.checkedParkingLotId,
                    createQuantity: this.count,
                    couponvalueId: this.couponvalueId
                };
                buyCoupon(form).then(res =>{
                    console.log(res);
                    if (res.code == 200){
                        if (res.data && res.data.totalPrice > 0){//有返回值并且金额大于0 去支付
                            let form = {
                                orderSn: res.data.orderSn,
                                parkinglotId: this.checkedParkingLotId,
                                totalAmount: parseFloat(res.data.totalPrice).toFixed(2),
                                goodsType: res.data.goodsType,
                                payType: 13,
                                openId:localStorage.getItem('userOpenId')||this.userOpenid 
                            };
                            pay(form).then(res =>{
                                this.$pay(res)
                            })
						}else {
							if("操作成功"==res.msg){
                            	this.$weui.alert('买券成功');
							}else{
								this.$weui.alert(res.msg);
							}
						}
                    }
                })
            },
            /*获取停车券列表**/
            getBusinessCouponList () {
                let queryForm = {
                    businessPhone: this.userPhone,
                    parkinglotId: this.checkedParkingLotId,
                    type: this.type
                };
                listBusinesscou(queryForm).then(res =>{
                    let feeList = res.data;
                    let unexpiredList = [];//未过期数组
                    let expiredList = [];//过期数组
                    if (feeList && feeList.length > 0) {
                        feeList.map((item,index) =>{
                            if (this.timeMarkOptions[item.ytype]){
                                this.$set(item,'timeMark',this.timeMarkOptions[item.ytype])
                            } else if (item.ytype == 2){//指定日期显示具体时间
                                this.$set(item,'timeMark',item.endLimitTime)
                            }
                            if (item.ytype == 2 && (this.transDate(item.endLimitTime) < Date.parse(new Date()))){//判断指定日期类型券是否过期
                                this.$set(item,'isExpiration',1);
                                expiredList.push(item)
							}else {//其他类型都是未过期
                                this.$set(item,'isExpiration',0);
								unexpiredList.push(item)
							}
                            item.actsaleMoney = parseFloat(item.actsaleMoney).toFixed(2);
                            if (item.type == 0){//次数
                                this.$set(item, 'title', '可抵扣一次')
                            }else if (item.type == 1){//时间
                                this.$set(item, 'title', (item.validateTime + '分钟'))
                            } else if (item.type == 2){//金额
                                this.$set(item, 'title', (item.validateFee + '元'))
                            }
                        });
                    }
                    this.feeList = unexpiredList.concat(expiredList);
                    if (this.feeList.length > 0){
                        this.feeList.map((item,index) =>{
                            if (index === 0){
                                if (item.isExpiration === 1){//过期
                                    this.feeIdx = undefined;
                                    this.couponvalueId = undefined;
                                } else {
                                    this.feeIdx = index;
                                    this.couponvalueId = feeList[index].coupontypeId;
                                }
                            }
                        })
					}
                })
            }
        }

    }
</script>

<style scoped lang="stylus">
	@import "~common/stylus/variable.styl"
	.weui-tab{
		.weui-tab-panel{
			padding 30px 10px 10px 10px
			display flex
			flex-wrap wrap
			justify-content space-between
			.fee-item-wrapper{
				color #B6B6B6
				width 48%
				height 105px
				padding 10px 0
				margin-bottom 15px
				box-shadow 0 0 6px #ddd
				border-radius 10px
				overflow hidden
				display flex
				flex-direction column
				align-items center
				position relative
				h6{
					font-weight 600
				}
				p{
					font-size 12px
					line-height 16px
				}
				.effect-date-wrapper{
					padding: 5px 0;
					border-top: 1px dashed #eee;
					position absolute
					left 0
					right 0
					bottom 0
					p{
						font-size 10px
						text-align center
						line-height 14px
					}
				}
				.active{
					background-color rgba(255,255,255,.5)
				}
				.icon-guoqi{
					font-size: 100px;
					opacity: .8;
					position: absolute;
					top: -20px;
					left -20px
				}
			}
			.active{
				color #fff
				background-color #07c160
			}
		}

	}
	.weui-cells{
		.weui-cell{
			padding 15px
		}
	}
	.weui-btn-area{
		margin-top 15px
		.weui-btn{
			width: 100%;
		}
		p{
			font-size $article-p
			color $article-p-color
			padding-top 10px
		}
	}
	.cube-scroll{
		position: relative;
		text-align: left;
		white-space: normal;
		max-height: 40%
		overflow hidden
		/*background: #ffffff;*/
		margin-bottom 20px
		.no-data-wrap{
			padding-top 20%
			display flex
			justify-content center
			align-items center
			.weui-article{
				color $no-data-font-color
				h1{
					font-size $no-data-font-size
				}
			}
		}

	}


</style>
